/**
 * ListingMedia Component
 *
 * Diamond Architecture: Responsive wrapper that shows ImageMosaic on desktop, carousel on mobile.
 * Manages shared PhotoGalleryModal state.
 */
import type { LocalizedText, S3Key } from '@letsgethome/types/branded';
import { cn } from '@letsgethome/ui/lib/utils';
import { useState } from 'react';

import { ImageMosaic } from './ImageMosaic';
import { ListingGallery } from './ListingGallery';
import { PhotoGalleryModal } from './PhotoGalleryModal';

interface ListingMediaProps {
  images: S3Key[];
  alt: LocalizedText | '';
  className?: string;
}

export function ListingMedia({ images, alt, className }: ListingMediaProps) {
  const [modalOpen, setModalOpen] = useState(false);

  if (!images.length) {
    return null;
  }

  const handleViewAll = () => {
    setModalOpen(true);
  };

  return (
    <>
      {/* Desktop: Mosaic Grid */}
      <div data-testid="listing-media" className={cn('hidden md:block', className)}>
        <ImageMosaic images={images} alt={alt} onViewAll={handleViewAll} />
      </div>

      {/* Mobile: Carousel */}
      <div data-testid="listing-media" className={cn('md:hidden', className)}>
        <ListingGallery images={images} alt={alt} onImageClick={handleViewAll} />
      </div>

      {/* Shared Fullscreen Modal */}
      <PhotoGalleryModal images={images} alt={alt} open={modalOpen} onOpenChange={setModalOpen} />
    </>
  );
}
